/**
 * 文本
 * @author yuxin.zhang 2018.11.9
 */

import React from 'react';
import InputNum from 'OK-InputNum';

import InputPassword from '_common/components/InputPassword';

import { FormType } from '../FormType';

import ItemContext from './ItemContext';
import LeftTitle from './LeftTitle';

const passwordType = 'password';

export default class ItemText extends ItemContext {
  constructor(props) {
    super(props);

    this.state = {
      errorMsg: '',
      dataError: false,
      value: '',
    };
  }

  UNSAFE_componentWillMount() {
    this.setValue(this.props.dataSource);
    this.setValue(this.props.isOptional);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setValue(nextProps.dataSource);
    this.setError(nextProps.dataSource);
    this.cleanError(nextProps.dataSource);
    this.cleanValue(nextProps.dataSource);
  }

  /**
   * 输入值变化监听
   * @param e
   */
  onChange = (e) => {
    this.onMoneyChange(e.target.value);
  };

  /**
   * 金额类型变化监听
   * @param value
   */
  onMoneyChange = (value) => {
    const { key, onChange, errorData, formType, extend, filter } =
      this.props.dataSource;
    const isOptional = this.props.isOptional;

    const val = filter ? filter(value, key) : value;
    let errorMsg = this.getErrorMsg(val, errorData);
    if (isOptional === true) {
      errorMsg = '';
    }
    const allow = errorMsg.length === 0;
    this.setState({
      value: val,
      errorMsg,
    });
    onChange && onChange(key, formType, val, allow, extend);
  };

  /**
   * 渲染文本类型
   * @returns {*}
   */
  renderFormLineText() {
    const { errorMsg, value, focus } = this.state;
    const {
      inputAttr,
      placeholderLeft,
      placeholderRight,
      bottomTips,
      formType,
      bottomArea,
    } = this.props.dataSource;
    let formBox = '';

    const isMoney = formType === FormType.MONEY;
    const isNumber = formType === FormType.NUMBER;
    const isPassword =
      formType === FormType.PASSWORD ||
      (inputAttr && inputAttr.type === passwordType);
    let className =
      // eslint-disable-next-line no-nested-ternary
      placeholderRight && placeholderRight.length !== 0
        ? 'form-transparent-input'
        : placeholderLeft && placeholderLeft.length !== 0
        ? 'form-transparent-input form-top-input'
        : 'input form-input';

    let Input = null;
    if (this.props?.dataSource?.noWheelEvent === true) {
      className += ' no-wheel-input';
    }
    const attr = {
      value,
      className,
      onChange: isMoney ? this.onMoneyChange : this.onChange,
      onFocus: this.onFocus,
      onBlur: this.onBlur,
    };

    if (isMoney) {
      // 金额类型
      Input = <InputNum {...inputAttr} {...attr} />;
    } else if (isPassword) {
      // 密码类型
      Input = <InputPassword {...inputAttr} {...attr} />;
    } else if (isNumber) {
      Input = <input type="number" {...inputAttr} {...attr} />;
    } else {
      // 其他不需特殊处理的类型
      Input = <input type="text" {...inputAttr} {...attr} />;
    }

    // 有居右提示的情况
    if (placeholderRight) {
      formBox = (
        <div className="form-input-box">
          <div className="mock-input-box" data-focus={focus}>
            <div className="mock-input" />
            {Input}
            <span className="placeholder-right">{placeholderRight}</span>
          </div>
          <span className="form-tips">{bottomTips}</span>
          <br />
          {bottomArea}
          <span className="form-error-tips">{errorMsg}</span>
        </div>
      );
    } else if (placeholderLeft) {
      formBox = (
        <div className="form-input-box">
          <div className="mock-input-box" data-focus={focus}>
            <span className="placeholder-left">{placeholderLeft}</span>
            {Input}
            <div className="mock-input" />
          </div>
          <span className="form-tips">{bottomTips}</span>
          <br />
          {bottomArea}
          <span className="form-error-tips">{errorMsg}</span>
        </div>
      );
    } else {
      formBox = (
        <div className="form-input-box">
          {Input}
          <br />
          {bottomArea}
          <span className="form-error-tips">{errorMsg}</span>
        </div>
      );
    }
    return formBox;
  }

  // 渲染下部提示
  renderTips(tips, isSpecial) {
    if (!tips || tips.length === 0) {
      return null;
    }
    return (
      <div className="tips-box">
        {tips.map((item, index) => {
          return (
            <div
              key={`tips${isSpecial ? 'Special' : ''}${index}`}
              className={`tips-item ${isSpecial ? 'especial' : ''}`}
            >
              {item}
            </div>
          );
        })}
      </div>
    );
  }

  render() {
    const { dataError, errorMsg } = this.state;
    const { dataSource } = this.props;
    const { bottomTips } = dataSource;
    return (
      <div
        className="form-item"
        data-error={dataError && errorMsg && errorMsg.length !== 0}
      >
        <LeftTitle dataSource={dataSource} />
        {this.renderFormLineText()}
        {this.renderTips(bottomTips)}
        {dataSource.rightArea}
      </div>
    );
  }
}

ItemText.defaultProps = {
  dataSource: {
    key: '',
    extend: null,
    placeholderRight: null,
    formType: FormType.TEXT,
    inputAttr: {},
    defaultValue: '',
    list: [],
    errorData: [],
    callback: null,
    onChange: null,
    onBlur: null,
    filter: (val) => {
      return val;
    },
  },
};
